module.exports = __webpack_public_path__ + "img/lock.8488a207.svg";